// extracted by mini-css-extract-plugin
export var details = "_ku-0";
export var inspectorPopover = "_ku-1";